var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClouds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 396.42 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#daa79d;}.cls-2{fill:#f6bdac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_copy",
    "data-name": "Layer 2 copy"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M345.76,202.16A71.21,71.21,0,0,0,291.61,85.21a67.43,67.43,0,0,0-93.05-59.08A88.46,88.46,0,0,0,47.33,88.48v.85A71.26,71.26,0,0,0,71.25,227.72h33.82A54.74,54.74,0,0,0,96.63,257h0a55,55,0,0,0,55,55H341.4a55,55,0,0,0,55-55h0A55,55,0,0,0,345.76,202.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15,156.46A56.25,56.25,0,0,1,57,102l6.06-1.58-.48-6.25c-.16-2.14-.24-4-.24-5.73a73.46,73.46,0,0,1,128.8-48.33L195,44.57l5.22-2.7a51.83,51.83,0,0,1,24-5.83,52.51,52.51,0,0,1,52.44,52.44c0,1.1-.05,2.27-.15,3.71l-.56,8h15.16A56.22,56.22,0,0,1,335,191.67a51.71,51.71,0,0,0-75-39.32,69.87,69.87,0,0,0-122.5,46c0,1.83.1,3.64.24,5.44a54.74,54.74,0,0,0-18.71,9H71.25A56.32,56.32,0,0,1,15,156.46Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClouds);
export default __webpack_public_path__ + "static/media/clouds.f9d9c96315718899957a5d325b38b064.svg";
export { ForwardRef as ReactComponent };